define(
    'models/forum.model',[
        'loader',
        'config',
        'helper',
        'sandbox',

        'models/admin_note.model',
        'collections/reports.collection'
    ],
    function (
        Loader,
        Config,
        Helper,
        Sandbox,

        AdminNoteModel,
        ReportsCollection
        )
    {
        var _ = Loader._;
        var $ = Loader.$;

        var ForumModel = Loader.Backbone.Model.extend({

            defaults: {
                host: document.domain,
                name: '',
                balance: null,
                desc: null,
                boardId: window['BoardID'],
                boardCat: window['BoardCat'],
                boardStyle: '',
                sign: '',
                baseDomain: '',
                groupTitle: '',
                note: null,
                reports: null,
                unreadReports: 0,
                twits: [],
                sets: {}
            },

            initialize: function()
            {
                var _this = this;
                this.model = this.get('model');
                this.set('note', new AdminNoteModel.initialize(this.model));
                this.set('reports', new ReportsCollection());

                _.defer(function(){
                    _this.setData();
                });

                this.model.bind('startApplication', function(){
                    _this.setName();
                    var user = _this.model.get('users').getMe();
                    _.defer(function(){
                        _this.getAdminData();
                    });

                    var initializedSocketData = {
                        "board_id": _this.get('boardId'),
                        "user_id": user.get('id'),
                        "group_id": user.get('groupId'),
                        "topic_id": $('#pun-viewtopic').attr('data-topic-id'),
                        "check": {
                            "board_id": _this.get('boardId'),
                            "group_id": user.get('groupId'),
                            "partner_id": window['PartnerID'],
                            // "sign": _this.get('sign'), // какая хуйня, иногда пусто, нет времени разбираться
                            "sign": window['ForumAPITicket'],
                            "user_id": user.get('id'),
                            "user_lastvisit": user.get('lastVisit')
                        }
                    };

                    Sandbox.transport.io.send('init', initializedSocketData);

                    Sandbox.transport.io.reconnect(function(){
                        console.log('socketio reconnected.');
                        Sandbox.transport.io.send('init', initializedSocketData);
                    });

                });
            },

            setName: function()
            {
                var $crumbs = $('#pun-crumbs1');

                if ($crumbs.find('a:first').length) {
                    this.set('name', $crumbs.find('a:first').text());
                } else if ($crumbs.find('span:first').length) {
                    this.set('name', $crumbs.find('span:first').text());
                } else {
                    var name = $crumbs.find('p:first').html();
                    name = name.substring(name.indexOf('»&nbsp;') + '»&nbsp;'.length);
                    this.set('name', name);
                }
            },

            setData: function()
            {
                this.set({
                    'boardId':      window['BoardID'],
                    'boardCat':     window['BoardCat'],
                    'boardStyle':   window['BoardStyle'],
                    'partnerId':    window['PartnerID'],
                    'sign':         window['ForumAPITicket'],
                    'baseDomain':   window['BaseDomain'],
                    'groupTitle':   window['GroupTitle']
                });
            },

            getDescription: function(callback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.getDesc, {"board_id": this.get('boardId')},
                    function(result){
                        _this.set('desc', result.board_description);
                        _.isFunction(callback) && callback(result);
                    },
                    function(err){}
                );
            },

            getBalance: function(callback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.getBalance, {"board_id": this.get('boardId')},
                    function(result){
                        _this.set('balance', result.board_balance);
                        _.isFunction(callback) && callback(result);
                    },
                    function(err){}
                );
            },

            saveDescription: function(text, callback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.editDesc, {
                        "board_id": this.get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id'),
                        "board_description": text
                    },
                    function(result){
                        _this.set('desc', text);
                        _.isFunction(callback) && callback(result);
                    },
                    function(err){},
                    true
                );
            },

            sendReport: function(obj, successCallback, errorCallback)
            {
                Sandbox.transport.send(Config.transport.channels.sendReport, {
                        "board_id": this.get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id'),
                        "report": obj.text,
                        "post_id": obj.postId,
                        "topic": {
                            "id": Helper.getParam('id'),
                            "title": window['FORUM'].get('topic.subject')
                        }
                    },
                    function(result){
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    },
                    true
                );
            },

            getReports: function(successCallback, errorCallback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.getReports, {
                        "board_id": this.get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id')
                    },
                    function(result){
                        _this.get('reports').update(result);
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    }
                );
            },

            markReportAsRead: function(obj, successCallback, errorCallback)
            {
                var _this = this;
                Sandbox.transport.send(Config.transport.channels.markReportAsRead, {
                        "board_id": this.get('boardId'),
                        "user_id": this.model.get('users').getMe().get('id'),
                        "reports_id": obj.reports_id
                    },
                    function(result){
                        _.isFunction(successCallback) && successCallback(result);
                    },
                    function(err){
                        _.isFunction(errorCallback) && errorCallback(err);
                    },
                    true
                );
            },

            collector: function(callback)
            {
                var _this = this;
                if (Config.modules.collector.enabled) {
                    Sandbox.transport.send(Config.transport.channels.collector, {
                            "board_id": this.get('boardId') || window['BoardID'],
                            "user_id": this.model.get('users').getMe().get('id'),
                            "board_cat": this.get('boardCat') || window['BoardCat'],
                            "group": {
                                "group_id": this.model.get('users').getMe().get('groupId'),
                                "group_title": this.get('groupTitle')
                            }
                        },
                        function(result){
                            _this.set('sets', result);
                            _.isFunction(callback) && callback(result);
                        },
                        function(err){}
                    );
                }
            },

            getAdminData: function()
            {
                var _this = this;
                if (document.location.href.indexOf('/admin_') == -1) return;

                Sandbox.transport.send(Config.transport.channels.admin, {
                        "board_id": this.get('boardId'),
                        "twitter_count": Config.modules.twitter.count
                    },
                    function(result){
                        _this.set('unreadReports', result.reportsNum);
                        _this.set('twits', result.twitter);
                    },
                    function(err){}
                );
            }

        });

        return {
            initialize: function(model)
            {
                return new ForumModel({
                    model: model
                })
            }
        }
    }
);

